export const delimiter = ","
export const defaultValue = "-"
export const priceRangeDelimiter = "-bis-"
